import React, { useState } from "react";
import "./TxnLookup.css";
import {
  getRawWebhooks,
  payinStatus,
  payinStatusInternal,
  payoutStatus,
  payoutStatusInternal,
} from "../../../config/LiveApi";
import PayInModal from "./PayInModal";
import Spinner from "../../Spin/Spinner";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { generatePDF } from "./GeneratePDF";
import PayoutsModels from "./PayoutsModals";

function IndividualStatus({
  inData,
  setInData,
  showTableData,
  setShowTableData,
}) {
  const [statusData, setStatusData] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [statusLoading, setStatusLoading] = useState(null);
  const [statusResponses, setStatusResponses] = useState([]);
  const [loadingItemId, setLoadingItemId] = useState(null);
  const role = useSelector((store) => store.userReducer.role);
  const token = useSelector((store) => store.userReducer.token);

  const checkStatus = async (item) => {
    let detail = {};

    if (item.type === "payin")
      detail = {
        orderId: item.orderId,
        transactionId: item.transactionId,
      };
    else
      detail = {
        merchantRefNo: item.orderId,
        transactionId: item.transactionId,
      };
    const isAdminOrMops = role === "admin" || role === "mops";
    let dataItem;
    if (item.type === "payin") {
      dataItem = isAdminOrMops
        ? await payinStatus(detail)
        : await payinStatusInternal(detail);
      dataItem.ORDER_ID = JSON.parse(item.request).orderId;
    } else {
     dataItem = isAdminOrMops
        ? await payoutStatus(detail)
        : await payoutStatusInternal(detail);
      dataItem.ORDER_ID = item.orderId;
    }

    setStatusResponses((prevResponses) => [
      ...prevResponses,
      { orderId: item.orderId, response: dataItem },
    ]);
  };

  const handleWebhookClick = async (item) => {
    setLoadingItemId(item.id);
    try {
      await getRawWebhook(item);
    } finally {
      setLoadingItemId(null);
    }
  };

  const getRawWebhook = async (item) => {
    const response = await getRawWebhooks(
      1,
      item.referenceId,
      item.transactionId
    );

    if (response.length === 0) {
      const secondRes = await getRawWebhooks(
        1,
        item.orderId,
        item.transactionId
      );

      if (secondRes.length === 0) {
        toast.error("No raw webhook data found for this transaction.");
        return;
      }

      setStatusResponses((prevResponses) => [
        ...prevResponses,
        { orderId: item.orderId, response: secondRes[0].rawWebhook },
      ]);
    }

    setStatusResponses((prevResponses) => [
      ...prevResponses,
      { orderId: item.orderId, response: response[0].rawWebhook },
    ]);
  };

  const copyStatus = async (item) => {
    try {
      let dataItem;

      if (
        item.responseStatus === "PROCESSING" ||
        item.responseStatus === "SETTLEMENT_PROCESS"
      ) {
        const detail =
          item.type === "payin"
            ? { orderId: item.orderId, transactionId: item.transactionId }
            : {
                merchantRefNo: item.orderId,
                transactionId: item.transactionId,
              };

        dataItem =
          item.type === "payin"
            ? await payinStatus(detail)
            : await payoutStatus(detail);

        if (item.type === "payin") {
          dataItem.ORDER_ID = JSON.parse(item.request).orderId;
        } else {
          dataItem.ORDER_ID = item.orderId;
        }

        setStatusResponses((prevResponses) => [
          ...prevResponses,
          { orderId: item.orderId, response: dataItem },
        ]);
      } else {
        dataItem = item.responseData || {};
      }
      const statusResponseString = JSON.stringify(dataItem, null, 2);
      await navigator.clipboard.writeText(statusResponseString);

      toast.success("Response copied to clipboard!");
    } catch (error) {
      console.error("Error fetching or copying status response: ", error);
      toast.error("Failed to fetch and copy response. Please try again.");
    }
  };

  const viewData = (item) => {
    setModalData(item);
    setOpenModal(true);
  };

  const copyAllResponses = () => {
    const allResponses = statusResponses.map((item) => item.response);
    const allResponsesString = JSON.stringify(allResponses, null, 2);

    navigator.clipboard
      .writeText(allResponsesString)
      .then(() => {
        toast.success("All responses copied to clipboard!");
      })
      .catch((error) => {
        console.error("Failed to copy all responses: ", error);
        toast.error("Failed to copy all responses. Please try again.");
      });
  };
  const handleGeneratePDF = (item) => {
    generatePDF(item, token);
  };
  return (
    <div>
      {statusLoading ? (
        <Spinner />
      ) : (
        <div>
          <div className="table-main-report-1">
            <table className="table-user-management">
              <thead className="table-user-report-1">
                <tr>
                  {(role == "super" ||
                    role == "operation" ||
                    role == "trafficManager" ||
                    role == "pros" ||
                    role == "compliance" ||
                    role == "subSuper") && (
                    <td>
                      <p className="user-table-head-report">Org Name</p>
                    </td>
                  )}
                  {(role == "super" ||
                    role == "operation" ||
                    role == "trafficManager" ||
                    role == "pros" ||
                    role == "compliance" ||
                    role == "subSuper") && (
                    <td>
                      <p className="user-table-head-report">Merchant Name</p>
                    </td>
                  )}
                  {(role == "super" ||
                    role == "operation" ||
                    role == "pros" ||
                    role == "trafficManager" ||
                    role == "compliance" ||
                    role == "subSuper") && (
                    <td>
                      <p className="user-table-head-report">PG Name</p>
                    </td>
                  )}
                  <td>
                    <p className="user-table-head-report">Order Id</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Transaction Mode</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Type</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Amount(₹)</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Status</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Transaction Date</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Updated Date</p>
                  </td>
                  {role === "operation" && (
                    <td>
                      <p className="user-table-head-report">Raw Webhook</p>
                    </td>
                  )}
                  <td>
                    <p className="user-table-head-report">View</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Action</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Copy</p>
                  </td>
                  {role == "pros" && (
                    <td>
                      <p className="user-table-head-report">Invoice</p>
                    </td>
                  )}
                </tr>
              </thead>

              <tbody>
                {inData.map((item, index) => {
                  item.requestData = JSON.parse(item?.request);
                  item.responseData = JSON.parse(item?.resposne);
                  const date = new Date(item.createdAt);
                  const formattedDate = date.toLocaleDateString();
                  const formattedTime = date.toLocaleTimeString();

                  return (
                    <tr key={index} className="user-table-head-report">
                      {(role == "super" ||
                        role == "operation" ||
                        role == "pros" ||
                        role == "trafficManager" ||
                        role == "compliance" ||
                        role == "subSuper") && (
                        <td>
                          <p className="table-user-data-report order-break">
                            {item.requestData?.orgName || item.orgName}
                          </p>
                        </td>
                      )}
                      {(role == "super" ||
                        role == "operation" ||
                        role == "pros" ||
                        role == "trafficManager" ||
                        role == "compliance" ||
                        role == "subSuper") && (
                        <td>
                          <p className="table-user-data-report order-break">
                            {item?.alias || item.userId}
                          </p>
                        </td>
                      )}
                      {(role == "super" ||
                        role == "operation" ||
                        role == "pros" ||
                        role == "trafficManager" ||
                        role == "compliance" ||
                        role == "subSuper") && (
                        <td>
                          <p className="table-user-data-report order-break">
                            {item.requestData?.pg || item.pg}
                          </p>
                        </td>
                      )}
                      <td>
                        <p
                          className="table-user-data-report order-break"
                          style={{ width: "150px" }}
                        >
                          {item.requestData?.orderId || item.orderId}
                        </p>
                      </td>
                      <td>
                        <p className="table-user-data-report order-break">
                          {item.requestData?.transactionMode ||
                            item.requestData.mode}
                        </p>
                      </td>
                      <td>
                        <p className="table-user-data-report type-data">
                          {item.type || ""}
                        </p>
                      </td>
                      <td>
                        <p className="table-user-data-report">
                          {item.RESPONSE_STATUS === "INVALID"
                            ? "INVALID"
                            : item.requestAmount}
                        </p>
                      </td>
                      <td>
                        <p
                          className="table-user-data-report"
                          style={{
                            color:
                              item.responseStatus === "SUCCESS" ||
                              item.responseStatus === "SETTLED"
                                ? "green"
                                : item.responseStatus === "FAILED" ||
                                  item.responseStatus === "SETTLEMENT_FAILED"
                                ? "red"
                                : item.responseStatus === "PROCESSING" ||
                                  item.responseStatus === "SETTLEMENT_PROCESS"
                                ? "orange"
                                : "black",
                            fontWeight: "bold",
                          }}
                        >
                          {item.responseStatus === "SETTLEMENT_PROCESS"
                            ? "PROCESSING"
                            : item.responseStatus === "SETTLEMENT_FAILED"
                            ? "FAILED"
                            : item.responseStatus}
                        </p>
                      </td>
                      <td>
                        <p className="table-user-data-report status-table">
                          {formattedDate} {formattedTime}
                        </p>
                      </td>
                      <td>
                        <p className="table-user-data-report status-table">
                          {(() => {
                            const date = new Date(item.updatedAt);
                            const formattedDate = `${date.getDate()}-${
                              date.getMonth() + 1
                            }-${date.getFullYear()}`;
                            const formattedTime = `${date
                              .getHours()
                              .toString()
                              .padStart(2, "0")}:${date
                              .getMinutes()
                              .toString()
                              .padStart(2, "0")}:${date
                              .getSeconds()
                              .toString()
                              .padStart(2, "0")}`;
                            return `${formattedDate} ${formattedTime}`;
                          })()}
                        </p>
                      </td>
                      {role === "operation" && (
                        <td>
                          <button
                            className="view-btn-1"
                            onClick={() => handleWebhookClick(item)}
                            disabled={loadingItemId === item.id}
                          >
                            {loadingItemId === item.id ? (
                              <span className="webhook-loader"></span>
                            ) : (
                              "Webhook"
                            )}
                          </button>
                        </td>
                      )}
                      <td>
                        <button
                          className="view-btn-1"
                          onClick={() => viewData(item)}
                        >
                          View
                        </button>
                      </td>
                      <td>
                        {item.responseStatus === "PROCESSING" ||
                        item.responseStatus === "SETTLEMENT_PROCESS" ? (
                          <button
                            className="view-btn-1"
                            onClick={() => checkStatus(item)}
                          >
                            Check Status
                          </button>
                        ) : (
                          <button
                            className="view-btn-1"
                            disabled
                            title="Check status is disabled"
                            style={{ cursor: "not-allowed", opacity: 0.6 }}
                          >
                            Check Status
                          </button>
                        )}
                      </td>

                      <td>
                        <button
                          className="view-btn-1"
                          onClick={() => copyStatus(item)}
                        >
                          Copy
                        </button>
                      </td>
                      {role === "pros" && (
                        <td>
                          <button
                            className="generate-btn"
                            onClick={() => handleGeneratePDF(item)}
                          >
                            Generate
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {openModal &&
            modalData &&
            (modalData.type === "payin" ? (
              <PayInModal modalData={modalData} setOpenModal={setOpenModal} />
            ) : (
              <PayoutsModels
                modalData={modalData}
                setOpenModal={setOpenModal}
              />
            ))}
        </div>
      )}

      {statusResponses.length > 0 && (
        <div className="json-responses">
          <div className="json-responses-header">
            <h3>Transaction Status Responses</h3>
            <button onClick={copyAllResponses} className="search-btn">
              Copy All
            </button>
          </div>

          {statusResponses.map((response, index) => (
            <div key={index} className="json-response">
              <pre>{JSON.stringify(response.response, null, 2)}</pre>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default IndividualStatus;
